import { ROUTE, ROUTE_GA_EVENT_PAGE } from "../../misc";
import { appEventGTag } from "../event";

export const event = (
    pathname: string,
    {
        formComment,
        formExperienceScore,
        formExperienceLabel
    }: {
        formComment: string;
        formExperienceScore: number;
        formExperienceLabel: string;
    }
) => {
    const routeKey = Object.keys(ROUTE).find(key => {
        return ROUTE[key] === pathname;
    });

    appEventGTag({
        page: ROUTE_GA_EVENT_PAGE[routeKey] ?? "home",

        eventName: "form_submit",
        eventLocationType: "form",
        eventLocationLabel: "form",
        eventLabel: "Feedback form is submitted",

        formType: "feedback",
        formComment,
        formExperienceScore,
        formExperienceLabel
    });
};
